const carouselItems = [
  {
    title: '热门影视剧集推荐专区',
    desc: '整理当前最受关注的影视剧资源入口，涵盖国产剧、韩剧、美剧等分类，帮助用户快速定位想看的剧集所在的视频平台。香蕉视频与蜜桃视频均有丰富片源。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20and%20drama%20series%20collage%20concept%20with%20warm%20ambient%20lighting%2C%20film%20reels%2C%20theater%20curtains%20in%20deep%20red%20tones%2C%20golden%20spotlights%2C%20elegant%20composition%20with%20movie%20poster%20aesthetic%2C%20dark%20background%20with%20soft%20glow%2C%20professional%20cinematography%20vibe&width=800&height=500&seq=carousel-card-01&orientation=landscape',
    tag: '剧集推荐',
    tagClass: 'bg-primary-100 text-primary-700',
  },
  {
    title: '短视频潮流风向标',
    desc: '聚焦91视频、西瓜视频等平台的热门短视频趋势，从搞笑段子到生活技巧，每天都有新鲜内容吸引眼球。紧跟网络热点，不错过每个爆款。',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20short%20video%20content%20creation%20concept%20with%20smartphone%20screens%20displaying%20colorful%20thumbnails%2C%20vibrant%20gradient%20background%20in%20coral%20and%20amber%20tones%2C%20floating%20like%20and%20play%20icons%2C%20modern%20social%20media%20aesthetic%2C%20clean%20geometric%20layout&width=800&height=500&seq=carousel-card-02&orientation=landscape',
    tag: '短视频',
    tagClass: 'bg-accent-100 text-accent-800',
  },
  {
    title: '海外影视资源聚合',
    desc: '樱花视频领衔的海外影视专区，提供日韩剧集、欧美大片等精选内容。字幕组精译作品持续更新，满足不同口味的观影需求。',
    image: 'https://readdy.ai/api/search-image?query=International%20film%20and%20television%20collage%20with%20Asian%20and%20Western%20cinema%20elements%2C%20cherry%20blossom%20petals%20floating%20on%20dark%20background%2C%20elegant%20golden%20and%20pink%20accents%2C%20subtle%20subtitle%20text%20patterns%2C%20cinematic%20lighting%20with%20soft%20bokeh%20effects&width=800&height=500&seq=carousel-card-03&orientation=landscape',
    tag: '海外资源',
    tagClass: 'bg-secondary-100 text-secondary-800',
  },
  {
    title: '原创达人内容生态',
    desc: '红桃视频与91视频等平台汇聚了大量原创内容创作者，从美食探店到旅行Vlog，优质自制内容层出不穷，打造属于你的个性化内容订阅清单。',
    image: 'https://readdy.ai/api/search-image?query=Creative%20content%20creator%20studio%20setup%20with%20camera%20equipment%20and%20warm%20ambient%20lighting%2C%20modern%20workspace%20aesthetic%2C%20vlogging%20gear%20on%20wooden%20desk%2C%20soft%20natural%20light%20streaming%20through%20window%2C%20cozy%20creative%20atmosphere%20with%20plants%20and%20tech%20gadgets&width=800&height=500&seq=carousel-card-04&orientation=landscape',
    tag: '原创达人',
    tagClass: 'bg-primary-100 text-primary-700',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">精选专题</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            聚焦热门视频内容方向，为您精选优质专题入口
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className={`text-xs px-2.5 py-1 rounded-full font-medium ${item.tagClass}`}>
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}